module.exports = __webpack_public_path__ + "static/media/998030.91142067.jpg";